import { Input } from 'framework7-react';
import { BaseSyntheticEvent, useCallback, useMemo } from 'react';
import './f7ComponentStyle.css';

interface TextFieldProps {
  value: string;
  onChange: (text: string) => void;
  pattern?: string;
  placeholder?: string;
  readonly?: boolean;
}
export const TextField = ({
  value,
  onChange,
  pattern,
  placeholder,
  readonly,
}: TextFieldProps) => {
  const error = useMemo(() => {
    return !!pattern
      ? !new RegExp(pattern).test(value ?? '')
        ? 'input-error'
        : ''
      : '';
  }, [pattern, value]);
  const handleChangeInput = useCallback(
    (e: BaseSyntheticEvent) => onChange(e.target.value),
    [onChange],
  );
  return (
    <Input
      readonly={readonly}
      defaultValue={value}
      className={error}
      required={!!(pattern && pattern !== '')}
      validate={!!(pattern && pattern !== '')}
      pattern={pattern}
      type={'text'}
      placeholder={placeholder}
      onInput={handleChangeInput}
    />
  );
};
export const TextAreaField = ({
  value,
  onChange,
  pattern,
  placeholder,
}: TextFieldProps) => {
  const error = useMemo(() => {
    return pattern
      ? !new RegExp(pattern).test(value)
        ? 'input-error'
        : ''
      : '';
  }, [pattern, value]);
  const handleChangeInput = useCallback(
    (e: BaseSyntheticEvent) => onChange(e.target.value),
    [onChange],
  );
  return (
    <Input
      defaultValue={value}
      className={error}
      type={'textarea'}
      required={!!(pattern && pattern !== '')}
      validate={!!(pattern && pattern !== '')}
      pattern={pattern}
      placeholder={placeholder}
      onInput={handleChangeInput}
    />
  );
};
